import axios, { AxiosRequestConfig } from 'axios'
import { message } from 'antd';
import { HttpResponse, SennoException } from '../api/grpc'
import i18n from '../i18n';

export const url = 'https://sennoapi.com'

export async function post(method, url: string, headers: any, body: any): Promise<HttpResponse> {
   
    let accessToken = localStorage.getItem('accessToken');
    let header = Object.assign({}, headers,  { 'senno-access-token': accessToken || '' });

    let data: AxiosRequestConfig = {
        method: method,
        headers: header,
        url: url,
        data: body,
    }
    let response = await axios(data)

    axios.interceptors.response.use(
        response => Promise.resolve(response),
        error => {
            console.log("err",{ error})
            let sennoError = new SennoException( error.response ? error.response.headers : {});
            console.log({sennoError})
            message.destroy();
            if(+sennoError.code === 2004) {
                message.error(i18n.t("loginInvaild"), 0)
            }
            else if(sennoError.message) {
                message.error(sennoError.message, 12)
            }
            return Promise.reject(error)
        }
    );

    return {
        status: response.status,
        headers: response.headers,
        body: response.data
    }
}   


export async function postNoToken(method, url: string, headers: any, body: any): Promise<HttpResponse> {
   
    let header = Object.assign({}, headers);

    let data: AxiosRequestConfig = {
        method: method, 
        headers: header,
        url: url,
        data: body,
    }
    let response = await axios(data)

    return {
        status: response.status,
        headers: response.headers,
        body: response.data
    }
} 